import { useEffect } from "react";

export const Seo = ({ title, description, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || "");

    let scripts = [];
    if (jsonLd) {
      scripts = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((data) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify(data);
        script.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(script);
        return script;
      });
    }
    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, [title, description, jsonLd]);

  return null;
};
